module.exports = function() {
  return new Worker(__webpack_public_path__ + "e3595bca8f57d8dfe349.worker.js");
};